import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

export const saveCheque = async (payload) => {
    try {
        const r = await axios.post(`${API_BASE_URL}/Accounts/Savecheque`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save cheque book';
    }
};
